import { create } from 'apisauce';

const apiClient = create({
    baseURL: 'https://dev.bit.cullinangroup.com:3443/kioskWebServices/v1/',
});

export default apiClient;
